const DEFAULT_SENTRY_DSN =
  "https://f4911f6348710732fe1ed36a6e6f08e6@o4511304134033408.ingest.de.sentry.io/4511304148910160";

const DEFAULT_TRACES_SAMPLE_RATE = 0.1;

type SentryRuntimeOptions = {
  dsn?: string;
  enableLogs?: string;
  tracesSampleRate?: string;
};

function parseTracesSampleRate(value: string | undefined): number {
  if (!value) {
    return DEFAULT_TRACES_SAMPLE_RATE;
  }

  const parsed = Number(value);
  return Number.isFinite(parsed) && parsed >= 0 && parsed <= 1
    ? parsed
    : DEFAULT_TRACES_SAMPLE_RATE;
}

export function createSentryRuntimeConfig(options: SentryRuntimeOptions) {
  return {
    dsn: options.dsn?.trim() || DEFAULT_SENTRY_DSN,
    enableLogs: options.enableLogs === "true",
    sendDefaultPii: false,
    tracesSampleRate: parseTracesSampleRate(options.tracesSampleRate),
  } as const;
}
